import { Controller } from "@hotwired/stimulus"

// Platform detection patterns (mirrors Ruby model)
const PLATFORM_PATTERNS = {
  youtube: [
    /youtube\.com\/watch/i,
    /youtu\.be\//i,
    /youtube\.com\/embed/i,
    /youtube\.com\/shorts/i
  ],
  spotify: [
    /open\.spotify\.com\/episode/i,
    /open\.spotify\.com\/show/i,
    /spotify\.com\/episode/i
  ],
  apple_podcasts: [
    /podcasts\.apple\.com/i,
    /itunes\.apple\.com.*podcast/i
  ],
  soundcloud: [
    /soundcloud\.com/i
  ],
  deezer: [
    /deezer\.com\/.*episode/i,
    /deezer\.com\/.*podcast/i
  ],
  anchor: [
    /anchor\.fm/i
  ],
  google_podcasts: [
    /podcasts\.google\.com/i
  ],
  podbean: [
    /podbean\.com/i
  ],
  buzzsprout: [
    /buzzsprout\.com/i
  ],
  transistor: [
    /transistor\.fm/i
  ]
}

const PLATFORM_ICONS = {
  youtube: "🎬",
  spotify: "🎧",
  apple_podcasts: "🍎",
  soundcloud: "☁️",
  deezer: "🎵",
  anchor: "⚓",
  google_podcasts: "🎙️",
  podbean: "🫘",
  buzzsprout: "🐝",
  transistor: "📻"
}

const PLATFORM_NAMES = {
  youtube: "YouTube",
  spotify: "Spotify",
  apple_podcasts: "Apple Podcasts",
  soundcloud: "SoundCloud",
  deezer: "Deezer",
  anchor: "Anchor",
  google_podcasts: "Google Podcasts",
  podbean: "Podbean",
  buzzsprout: "Buzzsprout",
  transistor: "Transistor"
}

export default class extends Controller {
  static targets = ["urlInput", "platformBadge", "platformIcon", "platformName", "submitBtn"]

  connect() {
    // Check initial URL value
    if (this.hasUrlInputTarget && this.urlInputTarget.value) {
      this.detectPlatform()
    }
  }

  detectPlatform() {
    const url = this.urlInputTarget.value.trim()
    
    if (!url) {
      this.hidePlatformBadge()
      return
    }

    let detectedPlatform = null
    
    for (const [platform, patterns] of Object.entries(PLATFORM_PATTERNS)) {
      if (patterns.some(pattern => pattern.test(url))) {
        detectedPlatform = platform
        break
      }
    }

    if (detectedPlatform) {
      this.showPlatformBadge(detectedPlatform)
    } else {
      this.hidePlatformBadge()
    }
  }

  showPlatformBadge(platform) {
    if (!this.hasPlatformBadgeTarget) return

    this.platformBadgeTarget.classList.remove("hidden")
    
    if (this.hasPlatformIconTarget) {
      this.platformIconTarget.textContent = PLATFORM_ICONS[platform] || "🎙️"
    }
    
    if (this.hasPlatformNameTarget) {
      this.platformNameTarget.textContent = PLATFORM_NAMES[platform] || platform
    }
  }

  hidePlatformBadge() {
    if (this.hasPlatformBadgeTarget) {
      this.platformBadgeTarget.classList.add("hidden")
    }
  }
}
